export const IconRotatedClasses = {
    ICON_ROTATE_NONE: [],
    ICON_ROTATE_90: ['fa-rotate-90'],
    ICON_ROTATE_180: ['fa-rotate-180'],
    ICON_ROTATE_270: ['fa-rotate-270'],
    ICON_ROTATE_HORIZONTAL: ['fa-flip-horizontal'],
    ICON_ROTATE_VERTICAL: ['fa-flip-vertical'],
    ICON_ROTATE_BOTH: ['fa-flip-both'],
}
